var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96798 4.16592C10.8536 2.61136 13.1464 2.61136 14.032 4.16592L21.7041 17.6324C22.5649 19.1433 21.4445 21 19.6721 21H4.32789C2.55546 21 1.4351 19.1433 2.29587 17.6324L9.96798 4.16592ZM12.9999 17C12.9999 17.5523 12.5522 18 11.9999 18C11.4477 18 10.9999 17.5523 10.9999 17C10.9999 16.4477 11.4477 16 11.9999 16C12.5522 16 12.9999 16.4477 12.9999 17ZM12.7499 9C12.7499 8.58579 12.4142 8.25 11.9999 8.25C11.5857 8.25 11.2499 8.58579 11.2499 9V14C11.2499 14.4142 11.5857 14.75 11.9999 14.75C12.4142 14.75 12.7499 14.4142 12.7499 14V9Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.a1fbbae8e2b8837d240983789f3e89fe.svg";